import { Box, SxProps, Theme } from "@mui/material";

type Props = {
  level?: number;
  square?: boolean;
  outline?: boolean;
  children: React.ReactNode | React.ReactNode[];
  sx?: SxProps<Theme>;
  onClick?: any;
};

export default function Surface({
  level = 1,
  square = false,
  outline = false,
  children,
  sx = {},
  onClick
}: Props) {
  const levels = [0, "one", "two", "three", "four"];

  let bg = "background.default";
  if (level > 0) {
    bg = "surface." + levels[Math.abs(level)];
  }

  return (
    <Box
      sx={{
        borderRadius: square ? 0 : 1,
        backgroundColor: bg,
        border: outline ? 1 : 0,
        borderColor: "surface.outline",
        ...sx
      }}
      onClick={onClick}
    >
      {children}
    </Box>
  );
}
